import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import EditableTable from "../../../components/editableTable/EditableTable";
import { updateAccountInfo, getAccountsInfo } from "../../../slice/adminHomeSlice";
import { AccountTypeEnum, UpgradeRequestEnum } from "../../../utils/enums";
import { useQueryState, parseAsInteger } from "nuqs";

const accountTypeOptions = Object.values(AccountTypeEnum);

function AccountsInfoTable() {
  const dispatch = useDispatch();
  const accountsInfo = useSelector((state) => state.adminHome.accountsInfo);
  const [page, setPage] = useQueryState("page", parseAsInteger.withDefault(1));
  const [pageSize, setPageSize] = useQueryState("pageSize", parseAsInteger.withDefault(10));
  const approvedAccounts = accountsInfo.filter((account) => account.upgradeRequest !== UpgradeRequestEnum.PROCESSING);
  const [searchTimeout, setSearchTimeout] = useState(null);

  const searchText = "Search by username";
  const searchFn = (e) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    setSearchTimeout(
      setTimeout(() => {
        dispatch(getAccountsInfo(e.target.value));
      }, 500),
    );
  };

  useEffect(() => {
    dispatch(getAccountsInfo());
  }, [dispatch]);

  const submitHandler = async (x) => (await dispatch(updateAccountInfo(x))).payload;

  const columnOptions = [
    {
      key: "username",
      editable: () => false,
      columnName: "User Name",
    },
    {
      key: "accountType",
      editable: () => true,
      type: "select",
      values: accountTypeOptions,
      filter: true,
      columnName: "Account Type",
    },
    {
      key: "sector",
      editable: () => false,
      columnName: "Sector",
      render: (row) => row.sectorName || row.sector || "-",
    },
    {
      key: "senderEmail",
      editable: () => true,
      type: "text",
      columnName: "Sender Email",
    },
    {
      key: "senderName",
      editable: () => true,
      type: "text",
      columnName: "Sender Name",
    },
    {
      key: "certCountRemaining",
      editable: () => true,
      type: "number",
      columnName: "Certs Remaining",
    },
  ];

  return <EditableTable tableName="Accounts Info" tableData={approvedAccounts} columnOptions={columnOptions} submitHandler={submitHandler} searchFn={searchFn} searchText={searchText} page={page} pageSize={pageSize} setPage={setPage} setPageSize={setPageSize} />;
}

export default AccountsInfoTable;
